import { useState } from 'react';
import { updatePassword } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Label } from '@/components/ui/Label';

export function OwnerSettingsPage() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordSaving, setPasswordSaving] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState(false);

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setPasswordError('');
    setPasswordSuccess(false);
    if (password.length < 6) {
      setPasswordError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    if (password !== confirmPassword) {
      setPasswordError('Las contraseñas no coinciden.');
      return;
    }
    const user = auth.currentUser;
    if (!user) {
      setPasswordError('No hay sesión activa.');
      return;
    }
    setPasswordSaving(true);
    try {
      await updatePassword(user, password);
      setPassword('');
      setConfirmPassword('');
      setPasswordSuccess(true);
    } catch (err) {
      console.error('Error cambiando contraseña', err);
      setPasswordError(err instanceof Error ? err.message : 'Error al guardar la contraseña.');
    } finally {
      setPasswordSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Configuración global</h1>
      <Card className="max-w-xl">
        <CardHeader>
          <CardTitle>Contraseña</CardTitle>
          <CardDescription>
            Establece o cambia tu contraseña para iniciar sesión con correo y contraseña.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleChangePassword} className="space-y-4">
            {passwordError && (
              <p className="text-sm text-destructive">{passwordError}</p>
            )}
            {passwordSuccess && (
              <p className="text-sm text-green-600">Contraseña guardada correctamente.</p>
            )}
            <div className="space-y-2">
              <Label htmlFor="ownerNewPassword">Nueva contraseña</Label>
              <Input
                id="ownerNewPassword"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                minLength={6}
                autoComplete="new-password"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="ownerConfirmPassword">Repetir contraseña</Label>
              <Input
                id="ownerConfirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Repite la contraseña"
                minLength={6}
                autoComplete="new-password"
              />
            </div>
            <Button type="submit" disabled={passwordSaving}>
              {passwordSaving ? 'Guardando...' : 'Establecer / Cambiar contraseña'}
            </Button>
          </form>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Modo mantenimiento y features</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Activar/desactivar modo mantenimiento y features globales. Próximamente.</p>
        </CardContent>
      </Card>
    </div>
  );
}
